import React, { PureComponent, Fragment } from 'react';
import { bp, megaText } from 'Styles/helpers';
import styled from 'styled-components';
import screen from 'superior-mq';
import Waypoint from 'react-waypoint';

export default class AboutHeroTextWave extends PureComponent {

  constructor() {
    super();
    this.title = React.createRef();
  }

  componentDidMount() {
    const splitTarget = this.title.current;

    this.aboutTitleText = new SplitText(splitTarget, { type: 'lines,words,chars' });
    const characters = this.aboutTitleText.chars;

    this.titleTl = new TimelineMax({
      paused: true,
      onComplete: this.resetText,
    });

    this.titleTl
      .set(this.title.current, { opacity: 1 })
      .set(characters, { willChange: 'transform, opacity' })
      .staggerFrom(characters, 0.7, { transformOrigin: '0% 100%', opacity: 0, scale: 0.8, x: -10, y: 10, stagger: { from: 'left', amount: 0.44 }, ease: Back.easeOut.config(1.8) }, 'null', '+=.7');

    if (!this.props.scrollIn) {
      this.titleTl.play();
    }
  }

  animateTitle = () => {
    this.titleTl.play();
  }

  resetText = () => {
    this.aboutTitleText.revert();
  }

  componentWillUnmount() {
    this.titleTl.kill();
  }

  render() {
    return (
      <Fragment>
        {this.props.scrollIn &&
          <Waypoint
            onEnter={this.animateTitle}
            bottomOffset={80}
          />
        }
        <AboutHeroHeadline ref={this.title}>
          {this.props.children}
        </AboutHeroHeadline>
      </Fragment>
    );
  }
}

const AboutHeroHeadline = styled.h1`
  ${megaText()}
  z-index: 2;
  color: ${props => props.theme.blue};
  backface-visibility: hidden;
  transform: translateZ(1px);
  font-kerning: none;

  @supports (mix-blend-mode: multiply) {
    mix-blend-mode: multiply;
  }

  ${screen.below(bp.mobile, `
    ${megaText(8.4)}
  `)};
`;
